import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosConfig";
import "../styles/AdminCalender.css";

const API_URL = "/api/calendar";

const AdminCalender = () => {

  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    months: "",
    lstyear: "",
    title: "",
    day: "",
    start_date: "",
    end_date: "",
    date_text: "",
    type: "activity"
  });

  /* ================================
      RESET FORM
  ================================= */

  const resetForm = () => {

    setForm({
      months: "",
      lstyear: "",
      title: "",
      day: "",
      start_date: "",
      end_date: "",
      date_text: "",
      type: "activity"
    });

    setEditId(null);
  };

  /* ================================
      DATE FORMAT DD-MM-YYYY
  ================================= */

  const formatDate = (date) => {

    if (!date) return "";

    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  /* ================================
      FETCH EVENTS
  ================================= */

  const fetchEvents = async () => {

    try {

      const res = await axios.get(API_URL);

      if (Array.isArray(res.data)) {
        setEvents(res.data);
      } else {
        setEvents([]);
      }

    } catch (err) {
      console.error("Fetch error", err);
      setEvents([]);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);


  /* ORDINAL SUFFIX */
const getOrdinal = (n) => {
  if (n > 3 && n < 21) return "th";
  switch (n % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
};

/* DATE TEXT FORMAT */
const formatDateText = (start, end) => {
  if (!start) return "";
  const startDate = new Date(start);
  const endDate = end ? new Date(end) : startDate;
  const sDay = startDate.getDate();
  const eDay = endDate.getDate();
  const sMonth = startDate.toLocaleString("en-IN",{month:"long"});
  const eMonth = endDate.toLocaleString("en-IN",{month:"long"});
  const sYear = startDate.getFullYear();
  const eYear = endDate.getFullYear();
  const sOrd = getOrdinal(sDay);
  const eOrd = getOrdinal(eDay);

  if(start === end){
    return `${sDay}${sOrd} ${sMonth} ${sYear}`;
  }
  if(sMonth === eMonth && sYear === eYear){
    return `${sDay}${sOrd} – ${eDay}${eOrd} ${sMonth} ${sYear}`;
  }
  return `${sDay}${sOrd} ${sMonth} – ${eDay}${eOrd} ${eMonth} ${eYear}`;
};

  const handleChange = (e) => {
    const { name, value } = e.target; 
    const updatedForm = {
      ...form,
      [name]: value
    };
  
    if(name === "start_date" || name === "end_date"){
        updatedForm.date_text = formatDateText(
        name === "start_date" ? value : form.start_date,
        name === "end_date" ? value : form.end_date
      );
    }
    setForm(updatedForm);
    };

  /* ================================
      OPEN ADD MODAL
  ================================= */
  const openAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  /* ================================
      OPEN EDIT MODAL
  ================================= */

  const openEditModal = (ev) => {

    setEditId(ev.event_id);

    setForm({
      months: ev.months,
      lstyear: ev.lstyear,
      title: ev.title,
      day: ev.day,
      start_date: ev.start_date ? ev.start_date.split("T")[0] : "",
      end_date: ev.end_date ? ev.end_date.split("T")[0] : "",
      date_text: ev.date_text,
      type: ev.type
    });

    setShowModal(true);
  };

  /* ================================
      SAVE EVENT
  ================================= */

  const saveEvent = async () => {

    try {

      await axios.post(API_URL, form);

      fetchEvents();

      setShowModal(false);

      resetForm();

    } catch (err) {
      console.error("Save error", err);
    }
  };

  /* ================================
      UPDATE EVENT
  ================================= */

  const updateEvent = async () => {

    try {

      await axios.put(`${API_URL}/${editId}`, form);

      fetchEvents();

      setShowModal(false);

      resetForm();

    } catch (err) {
      console.error("Update error", err);
    }
  };

  /* ================================
      DELETE EVENT
  ================================= */

  const deleteEvent = async (id) => {

    if (!window.confirm("Delete this event?")) return;

    try {

      await axios.delete(`${API_URL}/${id}`);

      fetchEvents();

    } catch (err) {
      console.error("Delete error", err);
    }

  };

  return (

    <div className="admin-calendar">

      <div className="admin-header">

        <h2>Academic Calendar</h2>

        <button
          className="add-btn"
          onClick={openAddModal}
        >
          Add Event
        </button>

      </div>

      <table className="calendar-table">

        <thead>

          <tr>
            <th>Month</th>
            <th>Academic Year</th>
            <th>Title</th>
            <th>Day</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Date Text</th>
            <th>Type</th>
            <th>Actions</th>
          </tr>

        </thead>

        <tbody>

          {events.length === 0 ? (

            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No events
              </td>
            </tr>

          ) : (

            events.map((ev) => (

              <tr key={ev.event_id}>

                <td>{ev.months}</td>
                <td>{ev.lstyear}</td>
                <td>{ev.title}</td>
                <td>{ev.day}</td>

                <td>{formatDate(ev.start_date)}</td>
                <td>{formatDate(ev.end_date)}</td>

                <td>{ev.date_text}</td>
                <td>{ev.type}</td>
                <td>

                  <button
                    className="edit-btn"
                    onClick={() => openEditModal(ev)}
                  >
                    Edit
                  </button>

                  <button
                    className="delete-btn"
                    onClick={() => deleteEvent(ev.event_id)}
                  >
                    Delete
                  </button>

                </td>

              </tr>

            ))

          )}

        </tbody>

      </table>

      {/* ============================
           MODAL
      ============================ */}

      {showModal && (

        <div className="modal-overlay">

          <div className="modal-box">

            <h3>{editId ? "Edit Event" : "Add Event"}</h3>

            <div className="form-grid">

              <input
                name="months"
                placeholder="Month"
                value={form.months}
                onChange={handleChange}
              />

              <input
                name="lstyear"
                placeholder="Year"
                value={form.lstyear}
                onChange={handleChange}
              />

              <input
                name="title"
                placeholder="Title"
                value={form.title}
                onChange={handleChange}
              />

              <input
                name="day"
                placeholder="Day"
                value={form.day}
                onChange={handleChange}
              />

              <div>

                <label>Start Date</label>

                <input
                  type="date"
                  name="start_date"
                  value={form.start_date}
                  onChange={handleChange}
                />

              </div>

              <div>

                <label>End Date</label>

                <input
                  type="date"
                  name="end_date"
                  value={form.end_date}
                  onChange={handleChange}
                />

              </div>

            </div>

            <div className="date-text-box">

              <label>Date Text (Auto)</label>

              <input
                name="date_text"
                value={form.date_text}
                disabled
              />

            </div>

            <div>
              <label>Type</label>
              <select
                name="type"
                value={form.type}
                onChange={handleChange}
              >
                <option value="activity">Activity</option>
                <option value="holiday">Holiday</option>
                <option value="exam">Exam</option>
                <option value="meeting">Meeting</option>
              </select>
            </div>

            <div className="modal-buttons">

              {editId ? (

                <button
                  className="update-btn"
                  onClick={updateEvent}
                >
                  Update
                </button>

              ) : (

                <button
                  className="save-btn"
                  onClick={saveEvent}
                >
                  Save
                </button>

              )}

              <button
                className="cancel-btn"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>

            </div>

          </div>

        </div>

      )}

    </div>

  );
};

export default AdminCalender;